import type { ReactNode } from 'react';

import classnames from 'classnames';

type PanelBodyProps = {
  children: ReactNode;
  className?: string;
  empty?: boolean;
};

export default function PanelBody({ children, className, empty, ...other }: PanelBodyProps) {
  return (
    <div className={classnames('panel-body', className, { 'empty-state': empty })} {...other}>
      {children}
    </div>
  );
}
